import { Navigate } from "react-router-dom";
import { useRef } from "react";
import { useIsAdmin } from "@/hooks/useIsAdmin";

export function AdminRoute({ children }: { children: JSX.Element }) {
  const { isAdmin, loading } = useIsAdmin();
  const hasConfirmedAdmin = useRef(false);

  if (isAdmin) {
    hasConfirmedAdmin.current = true;
  }

  if (loading && !hasConfirmedAdmin.current) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
      </div>
    );
  }
  if (!isAdmin) return <Navigate to="/" replace />;
  return children;
}